import React from 'react';
import TabContainer from '../../../../common/components/tab/containers/tab.containers';
import { useAppSelector } from '../../../../hooks/hooks';
import { selectListItems } from '../../../../redux/library/selector';
import { UploadMedia } from '../../../../common/components/common/upload-media';
import GlobalDbnTaxonomyDomainBasicInfoComponent from '../../global-dbn-taxonomy-domains/components/global-dbn-taxonomy-domain-basic-info.component';
import GlobalDbnRoutingPacksBasicInfoComponent from './global-dbn-routing-pack-basic-info';


export const GlobalDbnRoutingPacksComponent = ({ 
  setFunctionAttributes, 
  functionAttributes, 
  id, CommercialTier, 
  BluePrinyResgistryList, 
  parentDomain, 
  handleInnerFormChange, 
  selectedDomain, 
  selectedCategory,
  // handleFormItemChange,
   mediaFiles, 
   changeImage, 
   templateFiles,
   back, 
   handleFormTemplateItemChange,
   handleImageChange,
   handleTemplateSubmit,
   handleFormSubmit 
  }: any) => {
      const libraryData = useAppSelector(selectListItems)

  const tabItems = [
    {
      id: 1,
      title: 'Basic Information',
      component: <GlobalDbnRoutingPacksBasicInfoComponent
        handleInnerFormChange={handleInnerFormChange}
        selectedDomain={selectedDomain}
        BluePrinyResgistryList={BluePrinyResgistryList}
        selectedCategory={selectedCategory}
        CommercialTier={CommercialTier}
      />,
      isVisible: true,
    }
  ]

  return (
    <div className="flex flex-col items-center w-full px-5 h-[620px] overflow-auto">


      <TabContainer tabItems={tabItems} />

      <div className='flex w-full justify-end items-end'>
        <button
          onClick={back}
          type='button'
          className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
        >
          Back
        </button>
        <button
          className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
          onClick={handleFormSubmit}

          type="submit"
        >
          Save
        </button>
      </div>
    </div>
  )
}
export default GlobalDbnRoutingPacksComponent;
